import { useMemo } from 'react'

import { useFetchAllObjectQuery, useFetchAllSystemQuery } from '@redux/api'

import { TYPES_SOURCE_OPTIONS } from '@constants'
import { AutocompleteOption } from '@types'

export const useCommandSources = (
  isAnotherObjectWithRequestData?: boolean,
  availableRefObjectCodes?: string[]
) => {
  const {
    data: objects,
    isLoading: isLoadingObjects,
    isFetching: isFetchingObjects,
  } = useFetchAllObjectQuery(undefined, {
    skip: typeof isAnotherObjectWithRequestData === 'boolean' && !isAnotherObjectWithRequestData,
  })

  const {
    data: systems,
    isLoading: isLoadingSystems,
    isFetching: isFetchingSystems,
  } = useFetchAllSystemQuery()

  const loadingObjects = isLoadingObjects || isFetchingObjects
  const loadingSystems = isLoadingSystems || isFetchingSystems

  const objectsOptions: AutocompleteOption[] = useMemo(() => {
    if (!objects) return []

    return objects.map(object => ({
      id: object.code,
      label: object.title,
      typeResource: TYPES_SOURCE_OPTIONS.OBJECT,
      code: object.code,
    }))
  }, [objects])

  const refObjectOptions: AutocompleteOption[] = useMemo(() => {
    if (availableRefObjectCodes?.length) {
      return objectsOptions.filter(opt => availableRefObjectCodes.includes(opt.id as string))
    }

    return objectsOptions
  }, [objectsOptions])

  const systemsOptions: AutocompleteOption[] = useMemo(() => {
    if (!systems) return []

    return systems.map(system => ({
      id: system.code,
      label: system.title,
      typeResource: TYPES_SOURCE_OPTIONS.SYSTEM,
      code: system.code,
    }))
  }, [systems])

  return {
    objectsOptions,
    refObjectOptions,
    loadingObjects,
    systemsOptions,
    loadingSystems,
    objects,
  }
}
